const escapeCSV = (value) => {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const formatDate = (date) => {
  if (!date) return 'N/A';
  try {
    return new Date(date).toLocaleString();
  } catch {
    return 'N/A';
  }
};

const downloadCSV = (filename, content) => {
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + content], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const exportDashboardToCsv = (filename, data) => {
  const { ggr, statistics, filters } = data;
  const lines = [];

  lines.push('DASHBOARD METRICS EXPORT');
  lines.push('');

  lines.push('FILTER SETTINGS');
  lines.push(`Export Date,${escapeCSV(new Date().toLocaleString())}`);
  lines.push(`Date Range Start,${escapeCSV(formatDate(filters?.startDate))}`);
  lines.push(`Date Range End,${escapeCSV(formatDate(filters?.endDate))}`);
  lines.push(`Preset,${escapeCSV(filters?.preset || 'custom')}`);
  if (filters?.clientNames?.length > 0) {
    lines.push(`Selected Integrations,${escapeCSV(filters.clientNames.join(', '))}`);
  }
  lines.push('');

  lines.push('GGR BY INTEGRATION');
  lines.push('Integration,GGR');
  if (Array.isArray(ggr) && ggr.length > 0) {
    ggr.forEach((g) => {
      const ggrValue = parseFloat(g.ggr) || 0;
      lines.push(`${escapeCSV(g.client || 'Unknown')},${ggrValue.toFixed(2)}`);
    });
    const total = ggr.reduce((sum, g) => sum + (parseFloat(g.ggr) || 0), 0);
    lines.push(`TOTAL,${total.toFixed(2)}`);
  } else {
    lines.push('No data available,-');
  }
  lines.push('');

  lines.push('STATISTICS');
  lines.push('Metric,Value');
  if (statistics) {
    lines.push(`Total Bets (Count),${statistics.betsForPeriod ?? 'N/A'}`);
    lines.push(`Non-Rollbacked Bets (Count),${statistics.nonRollbackedBetsForPeriod ?? 'N/A'}`);
  } else {
    lines.push('No statistics available,-');
  }
  lines.push('');

  if (
    statistics?.betsForPeriodAmount &&
    Array.isArray(statistics.betsForPeriodAmount) &&
    statistics.betsForPeriodAmount.length > 0
  ) {
    lines.push('BETS BY CURRENCY');
    lines.push('Currency,Amount');
    statistics.betsForPeriodAmount.forEach((b) => {
      const amount = parseFloat(b.amount) || 0;
      lines.push(`${escapeCSV(b.currency)},${amount.toFixed(2)}`);
    });
  }

  const csvContent = lines.join('\n');
  downloadCSV(filename, csvContent);
};
